function applyMobileHeaderFix() {
  if (document.documentElement.clientWidth > 750) return;

  const columns = document.querySelector('.header__columns');
  const actions = document.querySelector('header-actions');
  const logo = document.querySelector('.header-logo');
  const menuIcon = document.querySelector('.header__icon--menu');
  const search = document.querySelector('.search-action');

  if (!columns || !actions || !logo) return;

  // ── Grid: hamburger | search | logo | empty | 3-icons ──
  columns.style.setProperty('grid-template-columns', '44px 40px 1fr 0px 96px', 'important');
  columns.style.setProperty('grid-template-areas', '"leftA leftB center rightA rightB"', 'important');
  columns.style.setProperty('align-items', 'center', 'important');
  columns.style.setProperty('height', '56px', 'important');
  columns.style.setProperty('padding-inline', '0px', 'important');

  // ── Logo: centered ──
  logo.style.setProperty('grid-area', 'center', 'important');
  logo.style.setProperty('justify-self', 'center', 'important');
  logo.style.setProperty('align-self', 'center', 'important');
  logo.style.setProperty('padding-inline', '0px', 'important');
  logo.style.setProperty('margin-inline', '0px', 'important');

  // ── Hamburger: leftA ──
  if (menuIcon) {
    menuIcon.style.setProperty('grid-area', 'leftA', 'important');
    menuIcon.style.setProperty('align-self', 'center', 'important');
    menuIcon.style.setProperty('justify-content', 'center', 'important');
    menuIcon.style.setProperty('width', '44px', 'important');
    menuIcon.style.setProperty('height', '44px', 'important');
    menuIcon.style.setProperty('padding', '0', 'important');
  }

  // ── Search: leftB ──
  if (search) {
    search.style.setProperty('display', 'flex', 'important');
    search.style.setProperty('grid-area', 'leftB', 'important');
    search.style.setProperty('align-items', 'center', 'important');
    search.style.setProperty('justify-content', 'center', 'important');
    search.style.setProperty('width', '40px', 'important');
    search.style.setProperty('height', '40px', 'important');
    search.style.setProperty('align-self', 'center', 'important');
    search.style.setProperty('padding', '0', 'important');
  }

  // ── Header-actions: rightB ──
  actions.style.setProperty('grid-area', 'rightB', 'important');
  actions.style.setProperty('display', 'flex', 'important');
  actions.style.setProperty('flex-direction', 'row', 'important');
  actions.style.setProperty('align-items', 'center', 'important');
  actions.style.setProperty('justify-content', 'flex-end', 'important');
  actions.style.setProperty('height', '56px', 'important');
  actions.style.setProperty('width', '96px', 'important');
  actions.style.setProperty('overflow', 'visible', 'important');
  actions.style.setProperty('gap', '0px', 'important');
  actions.style.setProperty('padding', '0px', 'important');

  // ── Each icon wrapper: 32px, no gap ──
  document.querySelectorAll('header-actions .header-actions__icon-wrap').forEach(el => {
    el.style.setProperty('width', '32px', 'important');
    el.style.setProperty('min-width', '32px', 'important');
    el.style.setProperty('height', '32px', 'important');
    el.style.setProperty('padding', '0', 'important');
    el.style.setProperty('margin', '0', 'important');
    el.style.setProperty('display', 'flex', 'important');
    el.style.setProperty('align-items', 'center', 'important');
    el.style.setProperty('justify-content', 'center', 'important');
    el.style.setProperty('flex-shrink', '0', 'important');
    el.style.setProperty('overflow', 'hidden', 'important');
  });

  // ── All SVGs: 16px ──
  document.querySelectorAll('header-actions svg').forEach(svg => {
    svg.style.setProperty('width', '16px', 'important');
    svg.style.setProperty('height', '16px', 'important');
    svg.style.setProperty('flex-shrink', '0', 'important');
  });

  // ── Account button wrapper ──
  const accountBtn = document.querySelector('header-actions .account-button');
  if (accountBtn) {
    accountBtn.style.setProperty('width', '32px', 'important');
    accountBtn.style.setProperty('min-width', '32px', 'important');
    accountBtn.style.setProperty('height', '32px', 'important');
    accountBtn.style.setProperty('padding', '0', 'important');
    accountBtn.style.setProperty('margin', '0', 'important');
    accountBtn.style.setProperty('display', 'flex', 'important');
    accountBtn.style.setProperty('align-items', 'center', 'important');
    accountBtn.style.setProperty('justify-content', 'center', 'important');
    accountBtn.style.setProperty('overflow', 'hidden', 'important');
    accountBtn.style.setProperty('flex-shrink', '0', 'important');
  }

  // ── shopify-account host + shadow root ──
  const shopifyAccount = document.querySelector('shopify-account');
  if (shopifyAccount) {
    shopifyAccount.style.setProperty('width', '32px', 'important');
    shopifyAccount.style.setProperty('height', '32px', 'important');
    shopifyAccount.style.setProperty('display', 'flex', 'important');
    shopifyAccount.style.setProperty('align-items', 'center', 'important');
    shopifyAccount.style.setProperty('justify-content', 'center', 'important');
    shopifyAccount.style.setProperty('flex-shrink', '0', 'important');
    shopifyAccount.style.setProperty('overflow', 'hidden', 'important');

    if (shopifyAccount.shadowRoot) {
      let shadowStyle = shopifyAccount.shadowRoot.querySelector('#mobile-fix-style');
      if (!shadowStyle) {
        shadowStyle = document.createElement('style');
        shadowStyle.id = 'mobile-fix-style';
        shopifyAccount.shadowRoot.appendChild(shadowStyle);
      }
      shadowStyle.textContent = `
        :host {
          width: 32px !important;
          height: 32px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          overflow: hidden !important;
        }
        button, a {
          width: 32px !important;
          height: 32px !important;
          min-width: unset !important;
          padding: 0 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
        }
        svg {
          width: 16px !important;
          height: 16px !important;
        }
      `;
    }
  }

  // ── Hide all labels ──
  document.querySelectorAll('header-actions .header-actions__label').forEach(el => {
    el.style.setProperty('display', 'none', 'important');
  });
}

function resetDesktopHeader() {
  if (document.documentElement.clientWidth <= 750) return;

  const elements = [
    '.header__columns',
    'header-actions',
    '.header-logo',
    '.header__icon--menu',
    '.search-action',
    'header-actions .account-button',
    'shopify-account',
  ];

  elements.forEach(selector => {
    const el = document.querySelector(selector);
    if (el) el.style.cssText = '';
  });

  document.querySelectorAll('header-actions .header-actions__icon-wrap').forEach(el => {
    el.style.cssText = '';
  });

  document.querySelectorAll('header-actions svg').forEach(svg => {
    svg.style.cssText = '';
  });

  document.querySelectorAll('header-actions .header-actions__label').forEach(el => {
    el.style.cssText = '';
  });

  // Remove shadow root style injection
  const shopifyAccount = document.querySelector('shopify-account');
  if (shopifyAccount?.shadowRoot) {
    const shadowStyle = shopifyAccount.shadowRoot.querySelector('#mobile-fix-style');
    if (shadowStyle) shadowStyle.remove();
  }
}

function handleResize() {
  if (document.documentElement.clientWidth <= 750) {
    applyMobileHeaderFix();
  } else {
    resetDesktopHeader();
  }
}

// ── Initial run after custom elements upgrade ──
requestAnimationFrame(() => requestAnimationFrame(() => {
  handleResize();
}));

// ── Re-apply on resize ──
window.addEventListener('resize', handleResize);

// ── Re-apply if header re-renders, throttled + width-guarded ──
const headerComp = document.querySelector('#header-component');
if (headerComp) {
  let mutationRafId = null;
  new MutationObserver(() => {
    if (document.documentElement.clientWidth > 750) return;
    if (mutationRafId) return;
    mutationRafId = requestAnimationFrame(() => {
      mutationRafId = null;
      applyMobileHeaderFix();
    });
  }).observe(headerComp, { childList: true, subtree: true, attributes: false });
}
